import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Role } from '../models';
import { filter, firstValueFrom, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Promise((resolve, reject) => {
      if (!this.authService.hasValidToken()) {
        this.authService.login(state.url);
        resolve(false);
      } else {
        resolve(true);
      }
    }).then(async (hasToken) => {
      if (!hasToken) return Promise.resolve(false);
      let role = route.data['role'] as Role;
      const hasRole = this.authService.hasRole(role);
      if (!role) return Promise.resolve(true);
      if (role) {
        if (!hasRole) {
          this.router.navigateByUrl('/page403');
          return false;
        }
      }
      await firstValueFrom(
        this.authService.rootPermissionLoaded$.pipe(
          filter((loaded) => loaded === true),
          take(1)
        )
      ).then((a) => {
        let permission = route.data['permission'] as string;
        if (!permission) return Promise.resolve(true);
        const hasPermissions =
          this.authService.permissionsService.hasPermission(permission);
        hasPermissions.then((a) => {
          if (!a) {
            this.router.navigateByUrl('/page403');
            return false;
          }
        });
      });
      return true;
    });
  }
}
